import React, { useState } from "react";

import { sendPasswordReset } from "services";

import { incomplete, useCancelAsyncOnUnmount, useNavigate, useToggleNavs } from "utils";

import { Button, Col, Form, Input, Link, MainPage, Row, Typography, Message as message } from "components";

import { AccountLogo } from "pages/app/account/components/AccountLogo";

export const Password = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const signal = useCancelAsyncOnUnmount()();

  useToggleNavs(false, false);

  const complete = (v) => {
    setLoading(true);
    sendPasswordReset({
      ...v,
      ...{ signal },
    })
      .then(() => {
        navigate("/sign-in");
        message({ content: "The reset link was sent", icon: "gremlin" });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <MainPage pageName={"sign-in-up"}>
      <Row className="mini-form">
        <Col>
          <AccountLogo />
          <Row>
            <Col>
              <Typography variant="h1">Admin password reset</Typography>
              <Typography variant="paragraph-m" className="margin-top-100 margin-bottom-0">
                Enter your email address to receive a link.
              </Typography>
            </Col>
          </Row>
          <Form name="signin" className="margin-top-400" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
            <Row>
              <Col>
                <Input
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                    },
                  ]}
                />
              </Col>
            </Row>
            <Row className="margin-bottom-200">
              <Col>
                <Link to="/sign-in">Remembered your password?</Link>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                    Send me a link
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </MainPage>
  );
};
